import React, { useContext } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import Context from "../../../Context";

export default function HeaderReportButton() {
  const cx = useContext(Context);
  let isActive = useRouteMatch("/report");

  let iconClass = "primary";
  let titleSuffix = "";

  const isPulse = false;
  const pulseRing = isPulse ? <span className="pulse-ring"></span> : "";

  if (isPulse) {
    iconClass = "info";
  }

  return (
    <div className="topbar-item">
      <Link to="/report/" title={`Отчеты ${titleSuffix}`}>
        <div
          className={`btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-${iconClass} ${
            isActive ? "bg-light" : ""
          }`}
        >
          <span className={`svg-icon svg-icon-xl svg-icon-${iconClass}`}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#000000">
              <g fill="#000000">
                <path
                  opacity="0.3"
                  d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM15 17C15 16.4 14.6 16 14 16H8C7.4 16 7 16.4 7 17C7 17.6 7.4 18 8 18H14C14.6 18 15 17.6 15 17ZM17 12C17 11.4 16.6 11 16 11H8C7.4 11 7 11.4 7 12C7 12.6 7.4 13 8 13H16C16.6 13 17 12.6 17 12ZM17 7C17 6.4 16.6 6 16 6H8C7.4 6 7 6.4 7 7C7 7.6 7.4 8 8 8H16C16.6 8 17 7.6 17 7Z"
                  fill="#000000"
                />
                <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="#000000" />
              </g>
            </svg>
          </span>
          {pulseRing}
        </div>
      </Link>
    </div>
  );
}
